<template>
  <div class="siteUnitEvents-page && siteUnits.length > 0">
    <SiteUnitEventsTable v-if="siteUnitEvents" :site-unit-events="siteUnitEvents" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { ROUTES_NAME } from '@/common/constants';
import SiteUnitEventsTable from '@/components/common/tables/SiteUnitEventsTable';

export default {
  name: ROUTES_NAME.siteUnitEvents,

  components: {
    SiteUnitEventsTable
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('siteUnitEvents', ['siteUnitEvents']),
    errorText() {
      return this.errors ? 'auth.errorMessage' : '';
    }
  },

  async mounted() {
    await this.toggleLoader();
    await this.fetchSiteUnitEvents();
    await this.toggleLoader();
  },

  methods: {
    ...mapActions('ui', ['toggleLoader']),
    ...mapActions('siteUnitEvents', ['fetchSiteUnitEvents'])
  }
};
</script>

<style lang="scss">
.siteUnitEvents-page {
  padding: 0 10px;
}
</style>
